module.exports = __webpack_public_path__ + "static/Diane-0e5d75caa284188d5ba9d21a3b280d3c.png";